import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Renderer2,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { GeneralService } from 'src/app/api/config/general.service';
import { ToolsService } from 'src/app/utils/tools.service';
import { constants } from 'src/app/constants';
import { ClientService } from 'src/app/api/sale/client.service';
import { UbigeoService } from 'src/app/api/config/ubigeo.service';
import { HttpHeaders } from '@angular/common/http';
import { LoadingModalComponent } from 'src/app/components/loading-modal/loading-modal.component';
declare var $: any;

@Component({
  selector: 'app-guests-extends',
  templateUrl: './guests-extends.component.html',
  styleUrls: ['./guests-extends.component.css']
})
export class GuestsExtendsComponent {
  @Output() onSubmitEvent = new EventEmitter<string>();
  @ViewChild(LoadingModalComponent) LoadingModalComponent: any;
  @ViewChild('searchInputCountry') searchInputCountry: any;

  branchofficeSlug: string = '';
  item: FormGroup;
  checkId: any;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;
  save_add: boolean = false;

  required_ubigeo: boolean = false;

  index_preview: any = null;

  // set values variables
  typeClientNatural: any = constants.CLIENT.TYPE[0];
  documentDni: any = constants.CLIENT.TYPE_DOCUMENT.DNI;
  documentRuc: any = constants.CLIENT.TYPE_DOCUMENT.RUC;

  typeDocumentSelected: any = null;
  departmentSelected: any = 0;
  provinceSelected: any = null;
  ubigeoEdit: any = null;
  imageUrl: any = null;
  fileUrlImage: any = null;
  fileUrl: any = null;

  typesclient: any = [];
  typesdocument: any = [];
  statusmarital: any = [];
  sexs: any = [];
  age_groups: any = constants.CLIENT.AGE_GROUP;

  // ubigeo data
  initialCountry: any = null;
  countries: any = [];
  departments: any = [];
  provinces: any = [];
  districts: any = [];

  service_alert: any = {
    class: 'success',
    message: '',
    show: false
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private alertifyMsg: AlertifyHelper,
    private globalService: GlobalService,
    private clientService: ClientService,
    private generalService: GeneralService,
    private ubigeoService: UbigeoService,
    public toolsService: ToolsService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.item = this.fb.group({});
    this.init();
  }

  get f(): { [key: string]: AbstractControl } {
    return this.item.controls;
  }

  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  init() {
    let init_age_group = constants.CLIENT.AGE_GROUP[0].id;
    let init_country_id = constants.CLIENT.COUNTRY[0].id;
    this.item = this.fb.group({
      document: ['', [Validators.required]],
      fullname: ['', [Validators.required, Validators.minLength(2)]],
      type_client: [this.typeClientNatural.id, [Validators.required]],
      typedocument_id: [this.documentDni.id, [Validators.required]],
      tradename: [''],
      ubigeo: [null],
      address: [null],
      cellphone: [null],
      telephone: [null],
      email: [null, [Validators.email]],
      date_birthday: [null],
      status: [null],
      sex: [null],
      url_image: [null],
      // nuevos campos ===
      country_id: init_country_id,
      age_group: init_age_group,
      is_client_resposible: false,
      url_file: [null]
    });
  }

  // FUNCTIONS LOADS DATAS

  editClient(_item: any, val_index: any) {
    this.LoadingModalComponent.show();
    this.isEdit = true;
    this.index_preview = val_index;
    this.loadData();
    //  get edit data ------
    this.item.patchValue({
      document: _item.document,
      fullname: _item.fullname,
      type_client: _item.type_client,
      typedocument_id: _item.typedocument_id,
      tradename: _item.tradename,
      ubigeo: _item.ubigeo,
      address: _item.address,
      cellphone: _item.cellphone,
      telephone: _item.telephone,
      email: _item.email,
      date_birthday: _item.date_birthday,
      status: _item.status,
      sex: _item.sex,
      url_image: _item.url_image,
      // nuevos campos ===
      country_id: _item.country_id,
      age_group: _item.age_group,
      is_client_resposible: _item.is_client_resposible,
      url_file: _item.url_file
    });
    this.LoadingModalComponent.hide();
    this.checkUbigeo();
  }

  loadData() {
    this.init();
    this.getTypeDocument();
    this.getTypeClient();
    this.getStatusMarital();
    this.getSexs();
    this.getCountries();
    this.getDepartments();

    if (this.isEdit) {
      // this.editData();
    } else {
      this.initialCountry = constants.CLIENT.COUNTRY[0];
    }

    (<any>$('[data-toggle="tooltip"]')).tooltip();
    this.focused();
  }

  editData() {
    // this.LoadingModalComponent.show();
    // this.clientService.get(this.checkId).subscribe({
    //   next: (data: any) => {
    //     let _item = data.data;
    //     this.item.patchValue({
    //       document: _item.document,
    //       fullname: _item.fullname,
    //       type_client: _item.type_client.split(' ').join(''),
    //       typedocument_id: _item.typedocument_id,
    //       tradename: _item.tradename,
    //       ubigeo: _item.ubigeo,
    //       address: _item.address,
    //       cellphone: _item.cellphone,
    //       telephone: _item.telephone,
    //       email: _item.email,
    //       date_birthday: _item.date_birthday,
    //       status: _item.status,
    //       sex: _item.sex,
    //       url_image: _item.url_image
    //     });
    //     this.LoadingModalComponent.hide();
    //     this.checkUbigeo();
    //   }
    // });
  }

  getTypeClient() {
    this.generalService.listTypeClient().subscribe({
      next: (data: any) => {
        this.typesclient = data;
      }
    });
  }

  getStatusMarital() {
    this.generalService.listStatusMarital().subscribe({
      next: (data: any) => {
        this.statusmarital = data;
      }
    });
  }

  getSexs() {
    this.generalService.listSexs().subscribe({
      next: (data: any) => {
        this.sexs = data;
      }
    });
  }

  getTypeDocument() {
    this.LoadingModalComponent.show();
    this.generalService.listTypeDocument().subscribe({
      next: (data: any) => {
        this.LoadingModalComponent.hide();
        this.typesdocument = data;
        this.changeTypeDocument();
      }
    });
  }

  getCountries() {
    this.generalService.listCountries().subscribe({
      next: (data: any) => {
        this.countries = data;
        if (this.isEdit) {
          this.initialCountry = this.toolsService.searchObjById(
            this.item.value.country_id,
            this.countries
          );
        }
      }
    });
  }

  getDepartments() {
    this.ubigeoService.departments().subscribe({
      next: (data: any) => {
        this.departments = data.results;
      }
    });
  }

  getProvinces(department_code: any) {
    this.ubigeoService.provinces(department_code).subscribe({
      next: (data: any) => {
        this.provinces = data.results;
        this.provinceSelected = null;
        this.required_ubigeo = true;
        if (this.ubigeoEdit != null) {
          this.provinceSelected = this.ubigeoEdit.substr(0, 4);
        }
      }
    });
  }

  getDistricts(department_code: any) {
    this.ubigeoService.districts(department_code).subscribe({
      next: (data: any) => {
        this.districts = data.results;
        this.item.patchValue({
          ubigeo: null
        });

        if (this.ubigeoEdit != null) {
          this.item.patchValue({
            ubigeo: this.ubigeoEdit
          });
        }
      }
    });
  }

  changeTypeDocument() {
    this.typeDocumentSelected = this.toolsService.searchArrById(
      this.item.value.typedocument_id,
      this.typesdocument
    );
    // this.item.patchValue({
    //   document: null
    // });
  }

  changeDepartment() {
    this.provinceSelected = null;
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    this.provinces = [];
    this.districts = [];
    if (this.departmentSelected != 0) {
      this.getProvinces(this.departmentSelected);
    }
  }

  changeProvince() {
    this.districts = [];
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    if (this.toolsService.strToNull(this.provinceSelected) != null) {
      this.getDistricts(this.provinceSelected);
    }
  }

  checkUbigeo() {
    let ubigeo = this.item.value.ubigeo;
    if (ubigeo != null) {
      this.ubigeoEdit = ubigeo;
      this.required_ubigeo = true;
      this.departmentSelected = ubigeo.substr(0, 2);
      this.getProvinces(this.departmentSelected);
      this.getDistricts(ubigeo.substr(0, 4));
    }
  }

  extractRuc() {
    let param_ = this.item.value.document;
    if (param_ != null) {
      this.LoadingModalComponent.show();
      this.generalService.extractRuc(param_).subscribe({
        next: (data: any) => {
          this.LoadingModalComponent.hide();
          if (data.success) {
            this.replaceExtractDataRuc(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  extractDni() {
    let param_ = this.item.value.document;
    if (!_.isEmpty(param_)) {
      this.LoadingModalComponent.show();
      this.generalService.extractDni(param_).subscribe({
        next: (data: any) => {
          this.LoadingModalComponent.hide();
          if (data.success) {
            this.replaceExtractDataDni(data.data);
            this.alertifyMsg.success('Datos extraídos correctamente');
          } else {
            this.alertifyMsg.warning(data.message);
          }
        }
      });
    } else {
      this.alertifyMsg.warning('El campo N° documento no puede estar vacío');
    }
  }

  replaceExtractDataDni(data: any) {
    this.item.patchValue({
      fullname: data.fullname,
      address: data.address
    });
  }

  replaceExtractDataRuc(data: any) {
    this.item.patchValue({
      fullname: data.name,
      address: data.address
    });

    this.service_alert.class = data.alert_status;
    this.service_alert.message =
      'El cliente se encuentra con estado ' +
      data.status +
      ' y en condición ' +
      data.condition;
    this.service_alert.show = true;

    if (data.district_id != '') {
      this.item.patchValue({
        ubigeo: data.district_id
      });
      this.checkUbigeo();
    }
  }

  selectCountry(item_: any) {
    this.item.patchValue({
      country_id: item_.id
    });
  }

  clearedSearchCountry(): void {
    this.item.patchValue({
      country_id: null
    });
    this.searchInputCountry.focus();
  }

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrl = event.target.files[0];
    }
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};
    if (this.validate()) {
      data.item = this.item.value;
      data.index_preview = this.index_preview;
      this.close();
      (<any>$('#openExtendsGuests')).modal('hide');
      this.onSubmitEvent.emit(data);
    }
  }

  validate() {
    let item_ = this.item.value;
    if (item_.typedocument_id == this.documentDni.id) {
      if (item_.document.length < this.documentDni.max_length) {
        this.alertifyMsg.warning('El DNI ingresado debe tener 8 dígitos.');
        (<any>$('#client_document')).focus();
        return false;
      }
    }

    if (item_.typedocument_id == this.documentRuc.id) {
      if (item_.document.length < this.documentRuc.max_length) {
        this.alertifyMsg.warning('El RUC ingresado debe tener 11 dígitos.');
        (<any>$('#client_document')).focus();
        return false;
      }
    }
    return true;
  }

  resetForm() {
    this.submitted = false;
    this.item.reset();
  }

  close() {
    this.isEdit = false;
    this.submitted = false;
    this.checkId = null;
    this.index_preview = null;
    this.ubigeoEdit = null;
    this.departmentSelected = 0;
    this.provinceSelected = null;
    this.item.reset();
  }

  focused() {
    setTimeout(() => {
      (<any>$('#client_document')).focus();
    }, 500);
  }
}
